export default "__VITE_ASSET__B6zzvkAv__"